import { render } from "./ThisWeeksSalesPurchasesChart.vue?vue&type=template&id=54bf10d2"
import script from "./ThisWeeksSalesPurchasesChart.vue?vue&type=script&lang=js"
export * from "./ThisWeeksSalesPurchasesChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__